// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-top:hover{background:rgba(0,0,0,.1)}.menu-top span{font-size:14px!important}.menu-top i{font-size:16px!important}.el-menu--horizontal>div{float:left}", ""]);
// Exports
module.exports = exports;
